import { Dialog } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import ProDetailsItem from 'components/foundation/details-item/ProDetailsItem/ProDetailsItem';
import { useOpenable } from 'hooks';
import { t } from 'i18next';
import { ClassName } from 'types/ClassName';

import IPosition from 'types/Position';
import { useFeatureFlags } from 'utils/features';
import { executeFunctionsCurried } from 'utils/functionUtils';
import { getPhotoVerificationSettings, getPhotoVerificationSettingsStatusTitle } from 'utils/positionUtils';
import PhotoVerificationSettingsForm from '../forms/PhotoVerificationSettingsForm';

export interface IPhotoVerificationSettingsDetailProps {
  className?: ClassName;
  editable: boolean;
  position: IPosition;
  onUpdate: () => Promise<any>;
}

const PhotoVerificationSettingsDetail = (props: IPhotoVerificationSettingsDetailProps) => {
  const { className, position, onUpdate, editable } = props;

  const isPhotoVerificationEnabled = useFeatureFlags('PHOTO_VERIFICATION');
  const formOpenable = useOpenable();

  function getPositionValue() {
    const photoVerificationSettings = getPhotoVerificationSettings(position);
    return getPhotoVerificationSettingsStatusTitle(photoVerificationSettings);
  }

  const classes = classNames('photo-verification-settings-detail', className);

  return (
    <>
      <ProDetailsItem
        title={t('Require Photo Verification')}
        onClick={formOpenable.open}
        value={getPositionValue()}
        hint={
          'Select if photo verification should only be required when using a Kiosk that requires it, or if the position should always photo verify when performing certain clock actions (Position settings will override any Kiosk settings).'
        }
        className={classes}
        disabled={!editable || !isPhotoVerificationEnabled}
      />
      <Dialog position={'center'} isOpen={formOpenable.isOpen} onClose={formOpenable.close}>
        <PhotoVerificationSettingsForm
          className="mt-4 p-8"
          position={position}
          onSubmit={executeFunctionsCurried(onUpdate, formOpenable.close)}
        />
      </Dialog>
    </>
  );
};

export default PhotoVerificationSettingsDetail;
